import React, { lazy, Suspense, useEffect, useState } from "react";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  useLocation,
  Navigate,
} from "react-router-dom";
import { ToastContainer } from "react-toastify";

import Header from "./components/Header";
import Footer from "./components/Footer";
import ScrollToTopArrow from "./components/ScrollToTop";
import PageTransition from "./components/PageTransition";
import { usePageTransition } from "./hooks/usePageTransition";

import Home from "./pages/Home";
import About from "./pages/About";
import Contact from "./pages/Contact";

import Events from "./pages/Events";

import StudentLife from "./pages/StudentLife";

// Alumni Pages
import Alumni from "./pages/Alumni";
import News from "./pages/News";

import "./App.css";

import Unsubscribe from "./pages/Unsubscribe";
import EventDetails from "./pages/EventDetails";

import Auth from "./pages/Auth";
const Dashboard = lazy(() => import("./pages/Dashboard"));

// Scroll to top on route change

function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo({ top: 0, left: 0, behavior: "auto" });
  }, [pathname]);
  return null;
}


// App content component that uses the transition hook
function AppContent() {
  const { isTransitioning, targetUrl, startTransition, completeTransition } =
    usePageTransition();

  return (
    <div className="min-h-screen flex flex-col">
      <Header startTransition={startTransition} />
      <main className="flex-grow">
        <Routes>
          {/* Main Routes */}
          <Route path="/" element={<Home />} />
          <Route path="/about-us" element={<About />} />
          <Route path="/contact" element={<Contact />} />
          {/* Events Routes */}
          <Route path="/events" element={<Events />} />
          <Route path="/events/:id" element={<EventDetails />} />{" "}
          {/* dynamic page */}
          {/* Student Life */}
          <Route path="/student-life" element={<StudentLife />} />
          {/* Alumni */}
          <Route path="/alumni" element={<Alumni />} />
          {/* Other */}
          <Route path="/news" element={<News />} />
        </Routes>
      </main>
  <Footer />
  <ScrollToTopArrow />
      <PageTransition
        isActive={isTransitioning}
        onComplete={completeTransition}
        targetUrl={targetUrl}
      />
    </div>
  );
}

function AdminRoute({ children }) {
  const [isLoggedIn, setIsLoggedIn] = useState(
    !!localStorage.getItem("ummes_token")
  );

  useEffect(() => {
    const handleStorageChange = () => {
      setIsLoggedIn(!!localStorage.getItem("ummes_token"));
    };
    window.addEventListener("storage", handleStorageChange);
    return () => window.removeEventListener("storage", handleStorageChange);
  }, []);

  return isLoggedIn ? children : <Navigate to="/admin-login" />;
}

function App() {
  return (
    <Router>
      <ScrollToTop />
      <ToastContainer position="top-right" autoClose={4000} />
      {/* Admin Feature */}
      <Routes>
        <Route path="/admin-login" element={<Auth />} />
        <Route
          path="/app/cp-4f3a2b-admin-portal-x8y7z"
          element={
            <Suspense fallback={<div>Loading...</div>}>
              <AdminRoute>
                <Dashboard />
              </AdminRoute>
            </Suspense>
          }
        />

        {/* Unsubscribe route without header/footer */}
        <Route path="/unsubscribe" element={<Unsubscribe />} />

        {/* All other routes with header/footer and transition */}
        <Route path="/*" element={<AppContent />} />
      </Routes>
    </Router>
  );
}
export default App;